import i18next from 'i18next';

i18next.addResources('es_CL', 'TimeModifier', {
  title: 'Tiempo:',
  delivery: 'DELIVERY',
  pickup: 'RETIRO',
  deliveryCapitalize: 'Delivery:',
  pickupCapitalize: 'Retiro:'
});

i18next.addResources('es_CR', 'TimeModifier', {
  title: 'Tiempo:',
  delivery: 'DELIVERY',
  pickup: 'RETIRO',
  deliveryCapitalize: 'Delivery:',
  pickupCapitalize: 'Retiro:'
});
